import { clientLogosData } from "@/mocks/homeData";

export default function ClientLogosSection() {
  const clients = clientLogosData.clients;
  const doubled = [...clients, ...clients];

  return (
    <section className="w-full py-10 md:py-14 bg-background-50 border-y border-background-200/70 overflow-hidden">
      <div className="w-full px-4 md:px-6 lg:px-10 mb-6 md:mb-8">
        <p className="text-center text-sm md:text-base font-semibold text-foreground-600 uppercase tracking-wider">
          {clientLogosData.headline}
        </p>
      </div>

      <div className="relative w-full">
        <div className="absolute left-0 top-0 bottom-0 w-16 md:w-24 bg-gradient-to-r from-background-50 to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-16 md:w-24 bg-gradient-to-l from-background-50 to-transparent z-10" />

        <div className="flex animate-marquee">
          {doubled.map((client, idx) => (
            <div
              key={`${client}-${idx}`}
              className="flex-shrink-0 px-6 md:px-10 py-2"
            >
              <span className="font-heading font-semibold text-lg md:text-xl text-foreground-400 hover:text-primary-500 transition-colors whitespace-nowrap select-none">
                {client}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}